var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff385c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m12 17l1-2v-5.1c1.7-0.5 3-2 3-3.9 0-2.2-1.8-4-4-4-2.2 0-4 1.8-4 4 0 1.9 1.3 3.4 3 3.9v5.1zm-2-11c0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2-1.1 0-2-0.9-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m16.3 10.6l-0.6 1.9c2.6 0.7 4.3 2.1 4.3 3.5 0 1.9-3.3 4-8 4-4.7 0-8-2.1-8-4 0-1.4 1.7-2.8 4.3-3.5l-0.6-1.9c-3.5 0.9-5.7 3-5.7 5.4 0 3.4 4.4 6 10 6 5.6 0 10-2.6 10-6 0-2.4-2.2-4.5-5.7-5.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.37c8de9755c40c3664ec5b7c69f1e4b6.svg";
export { ForwardRef as ReactComponent };